import React from "react";
import SetHeader from "./SetHeader";
import BreadCrumb from "../../layout/BreadCrumb";
import SideTreeMenu from "./SideTreeMenu";

function Datasets() {
  return (
    <div>
      <BreadCrumb breadcrumbs={[{ title: "Datasets" }]} />
      <SetHeader />
      <div className="flex items-center mt-[1.5rem] h-full">
           <SideTreeMenu/>
      </div>
   
    </div>
  );
}

export default Datasets;
